import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { H1, winnowHeading, link } from '../../../theme/typography';
import { themeColor, themeSize, themeColorWithOpacity } from '../../../theme/getters';
import { media } from '../../../theme/media';
import { animatedPlaceholder } from '../../../theme/mixins';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: ${({ small }) => (small ? '70vh' : '75vh')};
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${themeSize('contentPadding')}px;
  overflow: hidden;
`;

export const Placeholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  ${animatedPlaceholder};
`;

export const KioskImage = styled.img`
  max-width: 200px;
  max-height: 100px;
  object-fit: contain;
  margin-bottom: 40px;
`;

export const Title = styled(H1)`
  font-size: 45px;
  line-height: 53px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 8px;
  color: ${themeColor('white')};

  ${media.tablet`
    font-size: 80px;
    line-height: 110%;
    margin-bottom: 32px;
  `};
`;

export const Description = styled.h2`
  ${winnowHeading};
  color: ${themeColor('white')};
  text-align: center;
  width: 100%;
  margin: 0 auto auto;

  ${media.tablet`
    margin-top: 32px;
    max-width: 665px;
  `}
`;

export const Content = styled.section`
  position: relative;
  width: 100%;
  max-width: 800px;
  margin: auto;
  ${media.tablet`
    max-width: 996px;
  `};
`;

export const Links = styled.nav`
  margin-top: 56px;
  text-align: center;
`;

export const HeroLink = styled(Link)`
  display: inline-block;
  margin-right: 16px;
  margin-left: 16px;
  ${link};
  font-size: 18px;
  color: ${themeColor('white')};
  text-decoration-color: ${themeColorWithOpacity('white', 0.2)};
`;
